// Class: starling.filters.CompositeFilter

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $import = require("./../../import_stub").default;
var $extend = require("./../../extend_stub").default;
function starling_filters_FragmentFilter() {return require("./../../starling/filters/FragmentFilter");}
function starling_filters_CompositeEffect() {return require("./../../starling/filters/CompositeEffect");}
function openfl_geom_Point() {return $import(require("openfl/geom/Point"));}

// Constructor

var CompositeFilter = function() {
	(starling_filters_FragmentFilter().default).call(this);
}

// Meta

CompositeFilter.__name__ = ["starling","filters","CompositeFilter"];
CompositeFilter.__super__ = (starling_filters_FragmentFilter().default);
CompositeFilter.prototype = $extend((starling_filters_FragmentFilter().default).prototype, {
	process: function(painter,helper,input0,input1,input2,input3) {
		this.get_compositeEffect().set_texture(input0);
		this.get_compositeEffect().getLayerAt(1).texture = input1;
		this.get_compositeEffect().getLayerAt(2).texture = input2;
		this.get_compositeEffect().getLayerAt(3).texture = input3;
		if(input1 != null) {
			input1.setupTextureCoordinates(this.get_vertexData(),0,"texCoords1");
		}
		if(input2 != null) {
			input2.setupTextureCoordinates(this.get_vertexData(),0,"texCoords2");
		}
		if(input3 != null) {
			input3.setupTextureCoordinates(this.get_vertexData(),0,"texCoords3");
		}
		return (starling_filters_FragmentFilter().default).prototype.process.call(this,painter,helper,input0,input1,input2,input3);
	},
	createEffect: function() {
		return new (starling_filters_CompositeEffect().default)();
	},
	getOffsetAt: function(layerID,out) {
		if(out == null) {
			out = new (openfl_geom_Point().default)();
		}
		out.x = this.get_compositeEffect().getLayerAt(layerID).x;
		out.y = this.get_compositeEffect().getLayerAt(layerID).y;
		return out;
	},
	setOffsetAt: function(layerID,x,y) {
		this.get_compositeEffect().getLayerAt(layerID).x = x;
		this.get_compositeEffect().getLayerAt(layerID).y = y;
	},
	getColorAt: function(layerID) {
		return this.get_compositeEffect().getLayerAt(layerID).color;
	},
	setColorAt: function(layerID,color,replace) {
		if(replace == null) {
			replace = false;
		}
		this.get_compositeEffect().getLayerAt(layerID).color = color;
		this.get_compositeEffect().getLayerAt(layerID).replaceColor = replace;
	},
	getAlphaAt: function(layerID) {
		return this.get_compositeEffect().getLayerAt(layerID).alpha;
	},
	setAlphaAt: function(layerID,alpha) {
		this.get_compositeEffect().getLayerAt(layerID).alpha = alpha;
	},
	get_compositeEffect: function() {
		return this.get_effect();
	}
});
CompositeFilter.prototype.__class__ = CompositeFilter.prototype.constructor = $hxClasses["starling.filters.CompositeFilter"] = CompositeFilter;

// Init

Object.defineProperties(CompositeFilter.prototype,{ "compositeEffect" : { get : function () { return this.get_compositeEffect (); }}, "numLayers" : { get : function () { return this.get_numLayers (); }}});

// Statics




// Export

exports.default = CompositeFilter;


//////////////////
// WEBPACK FOOTER
// ./lib/_gen/starling/filters/CompositeFilter.js
// module id = 97
// module chunks = 0